import { render, staticRenderFns } from "./Visualizar.vue?vue&type=template&id=3747f7f0"
import script from "./Visualizar.vue?vue&type=script&lang=ts"
export * from "./Visualizar.vue?vue&type=script&lang=ts"
import style0 from "./Visualizar.vue?vue&type=style&index=0&id=3747f7f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports